import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

import { ActivatedRoute } from "@angular/router";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { BillTypeService } from "../../shared/bill/bill-type.service";
import { CommunityService } from "../../shared/services/community/community.service";
import { LoaderService } from "../../shared/services/loader.service";
import { Subject } from "rxjs/Subject";
import { Subscription } from "rxjs/Subscription";
import { TypeSetup } from "./../../shared/bill/type-setup";
import { debounceTime } from "rxjs/operator/debounceTime";

@Component({
  selector: "app-bill-management",
  templateUrl: "./bill-management.component.html",
  styleUrls: ["./bill-management.component.css"]
})
export class BillManagementComponent implements OnInit {
  query: string;
  community$: any;
  activeRouteIndex: any;
  communityId: string;
  bills$: any;
  bills = [];
  communityBills = [];
  modalReference: NgbModalRef;
  community: any;
  chosenBills = [];
  private _alert = new Subject<string>();
  subscription: Subscription;
  errorMessage;
  successMessage;
  currentBill;
  actionType: any;
  confirmationTitle: string;
  confirmationMessage: string;
  dropdownSettings;
  communityBillTypes$: BehaviorSubject<Array<TypeSetup>>;

  constructor(
    private communityService: CommunityService,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private billService: BillTypeService
  ) { }

  ngOnInit(): void {
    this.query = "";
    this.loaderService.startLoader();
    this.route.params.subscribe(params => {
      this.activeRouteIndex = params.index;
      this.communityId = params.communityId;
      this.community$ = this.communityService.getCommunityById(
        this.communityId
      ).subscribe(community => {
        this.community = community;
        this.loaderService.stopLoader();

      });
      this.billService.getCommunityBillTypes(this.communityId);
      this.bills$ = this.billService.communityBillTypes$;
      this.bills$.subscribe(bills => { this.communityBills = bills; });

    });

    this.billService.getBillTypes()
      .subscribe(bills => {
        this.bills = bills;
      });

    this.dropdownSettings = {
      singleSelection: false,
      text: "Select Bills",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "form-control fc-b s",
      labelKey: "name"
    };
  }

  open(modal, modalSize): void {
    this.modalReference = this.modalService.open(modal, { size: modalSize });
  }

  close(): void {
    this.modalReference.close();
    if (this.currentBill.length > 0) {
      this.currentBill = [];
      this.chosenBills = [];

    }
  }

  showAddModal(modal): void {
    this.bills = this.bills.filter(bill => {
      return !this.communityBills.find(communityBill => {
        return bill.id === communityBill.id;
      });
    });
    this.open(modal, "md");
  }

  addBill() {

    const choices = this.currentBill;

    for (const newBill of choices) {
      for (const bill of this.chosenBills) {
        if (newBill.name === bill.name) {
          const msgType = false;
          const msg = `Some bills have been added before already.`;
          this.showAlert(msgType, msg);

          return;

        }

      }

      this.chosenBills.push({
        name: newBill.name,
        id: newBill.id
      });

    }

    this.currentBill = [];

  }

  removeBill(index): void {
    this.chosenBills.splice(index, 1);
  }

  update(): void {
    this.billService.addBillsToCommunity(
      this.community,
      this.chosenBills
    );
    this.chosenBills.forEach(element => {
      this.communityBills.push(element);
    });
    this.close();
    const length = this.chosenBills.length;
    const word = length === 1 ? "bill has" : "bills have";
    const msgType = true;
    const msg = "The " + word + " been successfully added to this community.";
    this.showAlert(msgType, msg);
    this.chosenBills = [];
  }

  showAlert(msgType, msg): void {
    this.subscription = this._alert.subscribe(
      message =>
        msgType
          ? (this.successMessage = message)
          : (this.errorMessage = message)
    );
    debounceTime
      .call(this._alert, 3000)
      .subscribe(
        () =>
          msgType
            ? (this.successMessage = undefined)
            : (this.errorMessage = undefined)
      );
    this._alert.next(msg);
    this.subscription.unsubscribe();
  }

  confirmAction(type, bill: any, modal): void {
    this.currentBill = bill;
    this.actionType = type;
    const message = `Are you sure you want to ${type} "${bill.name}" in this community?`;
    this.confirm("Attention!", message, modal);
  }

  confirm(title, message, modal): void {
    this.confirmationTitle = title;
    this.confirmationMessage = message;
    this.open(modal, "sm");
  }

  disableBill(): void {
    this.billService.deactivateCommunity(this.currentBill.id, this.community.id);
    this.close();
    const msgType = true;
    const msg = "The bill been successfully disabled for this community.";
    this.showAlert(msgType, msg);
  }

  enableBill(): void {
    this.billService.reactivateCommunity(this.currentBill.id, this.community.id);
    this.close();
    const msgType = true;
    const msg = "The bill been successfully enabled for this community.";
    this.showAlert(msgType, msg);
  }

}



// WEBPACK FOOTER //
// ./src/app/community-management/bill-management/bill-management.component.ts